angular.module('app.api').factory('InviteFriendApi', [
  'api',
  function InviteFriendApi(api) {
    const inviteFriendApi = {
      getInviteFriendsEmail: async () => {
        return api.get('invite-friends/email')
      },
      sendReferralEmails: async (userId, friendsList, isExternal) => {
        return api.post(
          `invite-friends/user/${userId}/isExternal/${isExternal}`,
          friendsList
        )
      },
      createExternalUser: async payload => {
        return api.post('users/external', payload)
      },
    }
    return inviteFriendApi
  },
])



// WEBPACK FOOTER //
// ./scripts/invite-friend/invite-friend.api.js